<template>
<div class="chapter">
<div class="inner_page">
<h2 class="chtitle">1</h2>
<p class="centerb"><a id="page_7">Thursday Evening</a></p><a id="page_7">
<p class="noindent"><em class="italic">Tonight the spirits of the Ancient Ones walk among the sacred rocks.</em></p>
<p class="indent">On his first day as a new ranger at Petroglyphs National Monument, Nick Ellis heard people talk about the spirits. He hadn’t believed them until he experienced it for himself one night under the full moon. It rattled him so much he considered transferring. Free-roaming spirits had not been part of the job description.</p>
<p class="indent">But when he learned about this sacred space and how important it remained for the Pueblo Indians in the area, his initial fear drained away. It was replaced with a sense of peace and respect for what the place represented, and the ancient culture who had created the symbols.</p>
<p class="indent">Petroglyphs National Monument on the far west side of the bustling city of Albuquerque, New Mexico, is a popular tourist destination, and even locals love hiking the area. Tonight, after the last visitor left, Nick spent half an hour making sure the trails concealed no lingering tourists. Next, he walked toward the small amphitheater to check for items left behind by the day’s guests.</p>
<p class="indent">His pulse quickened when he heard a sound, and he stopped short. He took a deep breath and pulled out his flashlight. A young coyote stood on the low wall, gazing at him. Nick exhaled quietly, and the animal turned away. Then, with graceful ease, it leaped from the low wall and left as silently as it arrived.</p>
<p class="indent">Nick pointed the flashlight toward the right corner and let it play across the floor at the bottom. It illuminated a pile of clothing.</p>
<p class="indent"><em class="italic">Oh, great. Somebody forgot their jacket and backpack</em>.</p>
<p class="indent">He stepped closer and the flashlight fell from his hands. A body lay on the floor of the amphitheater.</p>
<p class="indent">And Nick, for the second time in his career, considered asking for a transfer.</p>
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 03_Chapter01.vue?2ad98438